import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { IconButton } from "@mui/material";
import { toast } from "react-toastify";
import ThemeSwitch from "../ThemeSwitch";
import { useThemeContext } from "../../../context/ThemeContext";
import "./style.css";

export default function TemporaryDrawer() {
  const [open, setOpen] = useState(false);
  const { darkMode, toggleTheme } = useThemeContext();

  const changeMode = () => {
    toggleTheme();
    toast.success("Theme Changed!", { toastId: "theme" });
  };

  return (
    <div>
      <IconButton
        sx={{ color: "var(--white)" }}
        onClick={() => setOpen(true)}
      >
        <MenuRoundedIcon />
      </IconButton>
      <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
        <div className="mobile-links">
          <a className="link" href="/">
            Home
          </a>
          <a className="link" href="/watchlist">
            Watchlist
          </a>
          <a className="link" href="/compare">
            Compare
          </a>
          <a className="link" href="/dashboard">
            Dashboard
          </a>
          <ThemeSwitch checked={darkMode} onChange={() => changeMode()} />
        </div>
      </Drawer>
    </div>
  );
}
